import { render, staticRenderFns } from "./u-footer-basic.vue?vue&type=template&id=676573cc&scoped=true&"
import script from "./u-footer-basic.vue?vue&type=script&lang=js&"
export * from "./u-footer-basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676573cc",
  null
  
)

export default component.exports